import * as React from 'react';
import { SVGProps } from 'react';

const PreferenceMatchEmpty = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 29 28"
    width="1em"
    height="1em"
    {...props}
  >
    <circle cx={14.5} cy={14} r={13.4} stroke="#045445" strokeWidth={1.2} />
  </svg>
);

export default PreferenceMatchEmpty;
